export const CustomEvents = {
  hoveredScreeningEvent: 'hoveredScreeningEvent',
  customScroll: 'customScroll',
}
